import { render, staticRenderFns } from "./PriceDialog.vue?vue&type=template&id=252ff694&"
import script from "./PriceDialog.vue?vue&type=script&lang=js&"
export * from "./PriceDialog.vue?vue&type=script&lang=js&"
import style0 from "./PriceDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('252ff694')) {
      api.createRecord('252ff694', component.options)
    } else {
      api.reload('252ff694', component.options)
    }
    module.hot.accept("./PriceDialog.vue?vue&type=template&id=252ff694&", function () {
      api.rerender('252ff694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceReal/components/PriceReal/PriceDialog.vue"
export default component.exports